import { render, staticRenderFns } from "./CentreProfileNewPage.vue?vue&type=template&id=dcdd2a7e&scoped=true&"
import script from "./CentreProfileNewPage.vue?vue&type=script&lang=js&"
export * from "./CentreProfileNewPage.vue?vue&type=script&lang=js&"
import style0 from "./CentreProfileNewPage.vue?vue&type=style&index=0&id=dcdd2a7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdd2a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
